import React from "react";
import { Button, Form } from "semantic-ui-react";
import { Formik } from "formik";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { DropDownList, FormInput } from "../../../../common";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isLoading, onGetCountries, onGetStatesByCountryId, onAddOffice } from "../officeActions";
import {
  getSelectedCompany,
} from "../../../../Global/CustomFunctions";

const AddOfficeForm = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const officeStore = useSelector((state) => state.officeReducer);
  const [getWorkplace, setWorkplace] = useState({
    name: officeStore.name,
    countryId: officeStore.country,
    stateId: officeStore.state,
    address: officeStore.address,
  });
  const [selectedValue, setSelectedValue] = useState(null);

  useEffect(() => {
    dispatch(onGetCountries());
  }, []); // Empty dependency array ensures the effect runs only once on mount

  useEffect(() => {
    if (selectedValue !== null && selectedValue !== "") {
      dispatch(onGetStatesByCountryId(selectedValue));
    }

  }, [selectedValue]); // Empty dependency array ensures the effect runs only once on mount

  // Handle result from Redux store
  useEffect(() => {
    if (officeStore?.states === undefined || officeStore?.states === null) {
      setSelectedValue(null); // Reset value if result is null
    }
  }, [officeStore]);

  const redirect = () => {
    let selectedCompany = getSelectedCompany();
    let link = `/${selectedCompany.name}/offices`;
    props.history.push(link);
  }

  const onSubmitBtnClick = async (values) => {
    // const leaveTypeId = await onGetAnnualLeaveId();
    dispatch(isLoading(true));
    dispatch(onAddOffice(values, props.history));
  };


  return (
    <div className="addOfficeInner">
      <div style={{ backgroundColor: "white", width: "50%", margin: "20px auto", padding: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", borderRadius: "10px" }}>
        <div>
          <div
            style={{
              backgroundColor: "#2185D0",
              textAlign: "center",
              padding: "5px 0 10px 0",
            }}
          >
            <h1 className="text-light border-2">Add Workplace</h1>
            <h6 className="text-light">Enter workplace Details</h6>
          </div>
          <Formik
            initialValues={{
              name: getWorkplace.name,
              countryId: getWorkplace.countryId,
              stateId: getWorkplace.stateId,
              address: getWorkplace.address
            }}
            onSubmit={(values) => onSubmitBtnClick(values)}
            validationSchema={yup.object().shape({
              name: yup.string()
                .max(100, t("app.officeDashboard.validationNameMax100"))
                .required(t("app.officeDashboard.validationNameRequired")),
              countryId: yup.number().positive().required(t("app.officeDashboard.validationLocationRequired")),
              stateId: yup.number().positive(),
              address: yup.string().max(255, t("app.officeDashboard.validationAddressMax255")),
            })}
          >
            {({ errors, touched, handleSubmit, setFieldValue, values }) => (
              <Form>
                <div
                  className="my-3 p-3 d-flex justify-content-center flex-column w-100"
                >
                  <div className="my-2">
                    <div>
                      <label htmlFor="Name" className="m-2 text-secondary">
                        Workplace Name
                      </label>
                    </div>

                    <FormInput
                      style={{
                        borderBottom: "2px solid #3BA8E9",
                        borderRadius: 0,
                        outline: "none",
                        borderTop: 0,
                        borderLeft: 0,
                        borderRight: 0,
                        width: "37.5vw",
                      }}
                      placeholder="Workplace Name"
                      value={values.name}
                      onChange={(event, data) =>
                        data && data.name
                          ? setFieldValue(data.name, data.value)
                          : ""
                      }
                      name="name"
                      control="input"
                    />
                    <div>
                      {touched.name && errors.name && (
                        <span className="text-danger mx-3">{errors.name}</span>
                      )}
                    </div>
                  </div>

                  <div className="my-2">
                    <div>
                      <label htmlFor="Name" className="m-2 text-secondary">
                        Workplace Location
                      </label>
                    </div>
                    <DropDownList
                      selection
                      value={values.countryId}
                      options={officeStore.countries}
                      clearable
                      fluid
                      search
                      placeholder="Select Country"
                      name="countryId"
                      onChange={(e, { value }) => {
                        setFieldValue("countryId", value);
                        setSelectedValue(value);
                      }
                      }
                      loading={officeStore.isLoading}
                    />
                  </div>
                  <div className="my-2">
                    {selectedValue !== null && <DropDownList
                      selection
                      value={values.stateId}
                      options={officeStore.states}
                      clearable
                      fluid
                      search
                      placeholder="Select State"
                      name="stateId"
                      onChange={(e, { value }) => {
                        setFieldValue("stateId", value);
                      }
                      }
                      loading={officeStore.isLoading}
                    />
                    }
                  </div>

                  <div className="">
                    <div>
                      <label htmlFor="Name" className="m-2 text-secondary">
                        Workplace Address
                      </label>
                    </div>

                    <FormInput
                      style={{
                        borderBottom: "2px solid #3BA8E9",
                        borderRadius: 0,
                        outline: "none",
                        borderTop: 0,
                        borderLeft: 0,
                        borderRight: 0,
                        width: "37.5vw",
                      }}
                      placeholder="Workplace Address"
                      value={values.address}
                      onChange={(event, data) =>
                        data && data.name
                          ? setFieldValue(data.name, data.value)
                          : ""
                      }
                      name="address"
                      control="input"
                    />
                    <div>
                      {touched.address && errors.address && (
                        <span className="text-danger mx-3">{errors.address}</span>
                      )}
                    </div>
                  </div>


                </div>
                <div style={{ paddingBottom: "20px" }} className="text-center">
                  <Button
                    type="submit"
                    loading={officeStore.isLoading}
                    content="Save"
                    onClick={() => handleSubmit(values)}
                    className="addBtn text-light"
                    style={{ backgroundColor: "#F2711D", borderRadius: "5px", padding: "10px 20px" }}
                  />
                  <Button
                    onClick={() => { redirect() }}
                    primary
                    content="Cancel"
                    className="cancelBtn"
                    style={{ borderRadius: "5px", padding: "10px 20px", marginLeft: "10px" }}
                  />

                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};
export default AddOfficeForm;